import { useAuth } from './AuthContext';
import { Button, Icon } from './components/ui';
import AuthLayout, { AuthMessage, homeFor } from './components/auth/AuthLayout';
import './NotFoundPage.css';

const TITLE = 'We can’t find that page';

/**
 * 404 — signed in it renders inside AppShell (Portal.dc.html's in-shell 404, with a way back to
 * the role's home); signed out it uses the auth frame (Auth.dc.html · 404) and points to log in.
 */
function NotFoundPage() {
    const { isAuthenticated, isInitialized, user } = useAuth();

    // Auth is restored from storage in an effect; wait so a signed-in user never sees the signed-out page flash.
    if (!isInitialized) return null;

    if (!isAuthenticated) {
        return (
            <AuthLayout>
                <AuthMessage tone="muted" icon="notFound" kicker="Error 404" title={TITLE} links={null}>
                    <Button variant="primary" size="lg" block to="/login">Go to log in</Button>
                </AuthMessage>
            </AuthLayout>
        );
    }

    const player = user?.role === 'player';
    return (
        <div className="nf-page">
            <span className="nf-tile" aria-hidden="true"><Icon name="notFound" size={32} /></span>
            <span className="nf-kicker">Error 404</span>
            <h1 className="eg-h1">{TITLE}</h1>
            <Button variant="primary" size="lg" to={homeFor(user?.role)} className="nf-home">
                {player ? 'Go to my dashboard' : 'Go to Profile'}
            </Button>
        </div>
    );
}

export default NotFoundPage;
